export default {"src":"/newStatic/_next/static/media/chrome-icon.04de7951.svg","height":24,"width":24};